import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';

const DEFAULT_CURRENCY = 'USD';

export function createCurrencyPublicApi({
  context,
}: {
  context: EcomPlatformViewerScriptContext;
}) {
  return {
    getCustomerSelectedCurrency: () => {
      const siteStore = context.siteStore;
      const currencyHeader = siteStore.getCurrencyHeader();
      if (currencyHeader) {
        return currencyHeader;
      }

      const siteCurrency = siteStore.siteCurrency;
      if (siteCurrency) {
        return siteCurrency;
      }

      return DEFAULT_CURRENCY;
    },
  };
}
